import React from 'react';
import { Box, FormControl, Select, MenuItem, Typography } from '@mui/material';
import { MetricType, PeriodType } from '../../../store/modules/insights/types';
import { getMetricDisplayName } from '../../../util/insightsUtils';
import { BinaryToggle } from '../../../components/common/BinaryToggle';

interface ChartControlsProps {
  metricType: MetricType;
  onMetricChange: (metric: MetricType) => void;
  periodType: PeriodType;
  onPeriodChange: (period: PeriodType) => void;
  disabled?: boolean;
  isParentMerchant?: boolean;
}

export const ChartControls: React.FC<ChartControlsProps> = ({
  metricType,
  onMetricChange,
  periodType,
  onPeriodChange,
  disabled = false,
  isParentMerchant = false,
}) => {
  const availableMetrics: MetricType[] = isParentMerchant
    ? [
        'gmv',
        'averageOrderValue',
        'authorizationRate',
        'transactionCount',
        'contributingMerchants',
        'refundGmv',
        'refundTransactionCount',
      ]
    : [
        'gmv',
        'averageOrderValue',
        'authorizationRate',
        'transactionCount',
        'refundGmv',
        'refundTransactionCount',
      ];

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        mb: 1,
        flexWrap: 'wrap',
        gap: 2,
      }}
    >
      <Box
        sx={{
          minWidth: { xs: 150, sm: 200 },
          maxWidth: { xs: 250, sm: 350 },
          flex: { xs: 1, sm: 'none' },
          width: { xs: 'auto', sm: '220px' },
        }}
      >
        <FormControl size="small" fullWidth disabled={disabled}>
          <Select
            value={metricType}
            onChange={(e) => onMetricChange(e.target.value as MetricType)}
            displayEmpty
            sx={{
              width: { xs: '100%', sm: '283px' },
            }}
          >
            {availableMetrics.map((metric) => (
              <MenuItem key={metric} value={metric}>
                <Typography
                  variant="medium"
                  sx={{
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    width: '100%',
                  }}
                >
                  {getMetricDisplayName(metric)}
                </Typography>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <BinaryToggle
        value={periodType}
        onChange={onPeriodChange}
        options={[
          { value: 'monthly', label: 'Monthly' },
          { value: 'quarterly', label: 'Quarterly' },
        ]}
        disabled={disabled}
        buttonWidth="122px"
      />
    </Box>
  );
};
